import { computed, defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { GetHanyoParam } from "~/api/Common/Commands";
import { Log } from "~/extensions/utils";
import { HanyoKb } from "~/extensions/utils/DefineTypes";
import { HanyoHelper } from "~/extensions/utils/HanyoHelper";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
const log = Log.create("KeiyakuInfoPanel");
export default defineComponent({
    name: "KeiyakuInfoPanel",
    async setup() {
        const router = useRouter();
        const kouzaCaption = commonStore.messages.PI0026;
        let personal = reactive(myPageStore.personal);
        const nyukyoKeiyaku = computed(() => myPageStore.selectedNyukyokeiyaku);
        // 口座種別の取得
        let gethanyoParam = [new GetHanyoParam(HanyoKb.KouzaSb)];
        let hanyoList = await HanyoHelper.getHanyoList(gethanyoParam);
        const bankType = hanyoList.GetByHanyoKb(HanyoKb.KouzaSb);
        const bankList = ref([]);
        //口座種別の文言設定
        const kouzaSbName = ref("");
        // 口座番号の桁調整とマスキング
        let maskingKouzaNumber = "";
        if (personal.kouzaNo !== null && personal.kouzaNo !== 0 && personal.kouzaNo !== -1) {
            const raw = personal.kouzaNo.toString().padStart(7, "0");
            maskingKouzaNumber = "*".repeat(raw.length - 4) + raw.slice(-4);
        }
        kouzaSbName.value = personal.kouzaSb === 1 ? "普通" : personal.kouzaSb === 2 ? "当座" : "";
        const toPasswordChangePage = () => {
            router.push({ name: "password-change" });
        };
        const toEditPage = () => {
            router.push({ name: "shinjosho-edit", query: { nyukyokeiyakuNo: myPageStore.selectedNyukyokeiyakuNo } });
        };
        bankList.value = bankType
            .filter(x => [1, 2].includes(x.value))
            .map(x => ({
            ...x,
            label: x.option1
        }));
        return {
            toPasswordChangePage,
            personal,
            nyukyoKeiyaku,
            kouzaCaption,
            kouzaSbName,
            maskingKouzaNumber,
            toEditPage
        };
    }
});
